import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import Filters, { useStaticStatesFilter } from "@/components/Elements/Filters";
import { ACTIVITIES_SORTS, ACTIVITIES_FILTERS } from "@/entities/activities";
import {
  getActivityCauserModel,
  getActivitySubjectModel,
  useActivitySubjectType,
} from "@/modules/activity";
import { ActivityEvent } from "@/modules/activity/activity-event";
import { CauserSubject } from "@/modules/causer-subject";
import ListTable from "@/modules/list-table";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";
import { useTableFilterSubjectType } from "@/modules/table-filter/table-filter-subject-type";
import { format, fromNow } from "@/utilities/date";

const ActivitiesTable = (listTableProps) => {
  const { t } = useTranslation();

  const activityStatesFilter = useStaticStatesFilter("activity");
  const subjectTypeFilter = useTableFilterSubjectType();
  const { getSubjectTypeName } = useActivitySubjectType();

  const columns = [
    {
      title: t("global:date"),
      dataIndex: "created_at",
      render: (created_at, { id }) => (
        <Link to={`/activities/${id}`} title={format(created_at, "LLLL")}>
          {fromNow(created_at)}
        </Link>
      ),
      sorter: true,
      sorterKey: ACTIVITIES_SORTS.CREATED_AT,
      key: ACTIVITIES_FILTERS.CREATED_AT,
      minWidth: "150px",
      filterDropdownProps: { placement: "bottom" },
      ...Filters.dateRange,
    },
    {
      title: t("global:user"),
      dataIndex: "causer",
      render: (causer, activity) => {
        const causerModel = getActivityCauserModel(activity);
        return (
          <CauserSubject type="causer" model={causerModel} item={causer} />
        );
      },
      sorter: true,
      key: "causer_name",
      ...TABLE_FILTER_TEXT,
    },
    {
      title: t("activity:subject"),
      dataIndex: "subject",
      render: (subject, activity) => {
        const subjectModel = getActivitySubjectModel(activity);
        return (
          <CauserSubject type="subject" model={subjectModel} item={subject} />
        );
      },
      sorter: true,
      key: "subject_name",
      ...TABLE_FILTER_TEXT,
    },
    {
      title: t("activity:subjectType"),
      dataIndex: "subject_type",
      render: (_subjectType, activity) => {
        const subjectType = getSubjectTypeName(activity);
        return <Typography.Text>{subjectType}</Typography.Text>;
      },
      sorter: true,
      ...subjectTypeFilter,
    },
    {
      title: t("activity:event"),
      dataIndex: "event",
      render: (_event, activity) => <ActivityEvent activity={activity} />,
      sorter: true,
      ...activityStatesFilter,
    },
  ];

  return <ListTable columns={columns} {...listTableProps} />;
};

export default ActivitiesTable;
